var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6298 21.2234H6.36311C4.69477 21.2234 3.17311 19.94 2.89811 18.29L1.67894 10.9934C1.48644 9.85674 2.03644 8.39925 2.94394 7.67508L9.29645 2.58754C10.5248 1.59754 12.4589 1.60671 13.6964 2.59671L20.0489 7.67508C20.9473 8.39925 21.4973 9.85674 21.314 10.9934L20.0948 18.29C19.8198 19.9125 18.2706 21.2234 16.6298 21.2234ZM11.4873 3.23839C11.0015 3.23839 10.5156 3.38503 10.1581 3.6692L3.80561 8.75674C3.28311 9.17841 2.92562 10.1134 3.03562 10.7734L4.25478 18.07C4.41978 19.0325 5.38227 19.8484 6.36311 19.8484H16.6298C17.6106 19.8484 18.5731 19.0325 18.7381 18.0609L19.9573 10.7642C20.0673 10.1042 19.7006 9.16007 19.1873 8.74757L12.8348 3.6692C12.4681 3.38503 11.9823 3.23839 11.4873 3.23839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5026 15.4393C9.86177 15.4393 8.52344 14.101 8.52344 12.4601C8.52344 10.8193 9.86177 9.48096 11.5026 9.48096C13.1434 9.48096 14.4818 10.8193 14.4818 12.4601C14.4818 14.101 13.1434 15.4393 11.5026 15.4393ZM11.5026 10.856C10.6226 10.856 9.89844 11.5801 9.89844 12.4601C9.89844 13.3401 10.6226 14.0643 11.5026 14.0643C12.3826 14.0643 13.1068 13.3401 13.1068 12.4601C13.1068 11.5801 12.3826 10.856 11.5026 10.856Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home_white.7289ba8437f4407756de1fafd4ffe8b9.svg";
export { ForwardRef as ReactComponent };